import React, { useEffect, useState } from "react";
import Tree from "react-d3-tree";
import ButtonActionIcon from "../../components/BuilderComponents/ButtonActionIcon";
import BuilderModal from "../../Layouts/Modal/BuilderModal";
import { useParams } from "react-router-dom";
import AppLeftSideBar from "../../components/SideBar/AppLeftSideBar";
import Loader from "../../Layouts/Loader/Loader";
import Input from "../../components/FormComponents/Input";
import SingleSelectBox from "../../components/FormComponents/SingleSelectBox";
import Button from "../../components/FormComponents/Button";
import axiosInstance, { handleApiError } from "../../services/axiosService";
import { toastSuccess } from "../../utils/toastUtils";

const OrgStructure = () => {
  const [hierarchyData, setHierarchyData] = useState({});
  const [isEditopen, setIsEditopen] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const { orgId } = useParams();
  const nodeSize = { x: 100, y: 100 };
  const foreignObjectProps = { width: nodeSize.x, height: nodeSize.y, x: -50 };

  const getUserHierarchy = async () => {
    try {
      setIsLoading(true);
      const { data } = await axiosInstance.get(`/org/${orgId}/users-hierarchy?depth=100`);
      setIsLoading(false);
      setHierarchyData(data);
    } catch (error) {
      handleApiError(error);
    }
  };
  const editUser = async (id, role, manager) => {
    try {
      const obj = {
        app_operation: "add",
        // apps_id: [selectedApplication],
        designation: role,
        dot_reporting_managers_id: [],
        manager_id: manager
      };

      const { message } = await axiosInstance.patch(`/user-service/org/${orgId}/user/${id}`, obj);

      toastSuccess(message);
      const hierarchyCopy = JSON.parse(JSON.stringify(hierarchyData));
      // //api call to re-render tree with updated data
      // getUserHierarchy();
      updateHierarchyData(hierarchyCopy, id, role, manager);
      removeUserById(hierarchyCopy, id, manager);
      addUserById(hierarchyCopy, manager, modifiedUser);

      setHierarchyData(hierarchyCopy);
    } catch (error) {
      handleApiError(error);
    }
  };

  // to update hierarchyData state to render updated designation and manager
  const updateHierarchyData = (user, id, role, manager) => {
    if (user.user_id === id) {
      user.designation = role;
      user.manager_id = manager;
    }

    if (user.children && user.children.length > 0) {
      user.children.forEach((child) => {
        updateHierarchyData(child, id, role, manager);
      });
    }
  };
  //variable to store removed child when manager is changed to push that in manager array
  let modifiedUser;

  //to add removed child when manager is changed to push that in manager array
  const addUserById = (data, manager, child) => {
    if (data.user_id === manager) {
      if (!data.children) {
        data.children = [];
      }
      child.manager_id = manager;
      data.children.push(child);

      return;
    }

    if (data.children) {
      for (const subData of data.children) {
        addUserById(subData, manager, child);
      }
    }
  };
  //to remove child when manager id is changed
  const removeUserById = (data, id) => {
    if (!data || !Array.isArray(data.children)) {
      return data;
    }
    data.children = data.children.filter((child) => {
      if (child.user_id === id) {
        modifiedUser = JSON.parse(JSON.stringify(child));
        // addUserById(data, managerId, child)
        return false;
      } else {
        removeUserById(child, id);
        return true;
      }
    });
  };
  // to provide allowed managers list i.e not self and not children
  const filterManagers = (id, obj = hierarchyData) => {
    let result = [];
    if (obj.user_id === id) {
      // If the id matches, return an empty array
      return result;
    } else {
      // If the id does not match, push the object into the result array
      result.push({ id: obj.user_id, name: obj.name });
    }

    if (obj.children && obj.children.length > 0) {
      for (let i = 0; i < obj.children.length; i++) {
        // Concatenate the results from the children
        result = result.concat(filterManagers(id, obj.children[i]));
      }
    }

    return result;
  };

  useEffect(() => {
    getUserHierarchy();
    // getAllOrgUsers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const renderForeignObjectNode = ({ nodeDatum, toggleNode, foreignObjectProps }) => (
    <g>
      {/* `foreignObject` requires width & height to be explicitly set. */}
      <foreignObject {...foreignObjectProps}>
        <div className="user_node" onClick={toggleNode}>
          <div className="user_name">{nodeDatum.name}</div>
          <div className="user_designation">{nodeDatum.designation}</div>
          <div className="edit_user_designation">
            <ButtonActionIcon
              type="edit"
              onClick={(e) => {
                setIsEditopen(nodeDatum);
                e.stopPropagation();
              }}
            />
          </div>
        </div>
      </foreignObject>
    </g>
  );
  return (
    <div className="application_container">
      <AppLeftSideBar type="app" />
      {isLoading ? (
        <div className="add_form_container">
          <Loader />
        </div>
      ) : (
        <div className="dashboard_outer_section">
          <div className="org_structure_wrapper">
            {/* <canvas></canvas> */}
            {Object.keys(hierarchyData).length > 0 ? (
              <div id="treeWrapper" className="w_100" style={{ height: "calc(100% - 64px)" }}>
                <Tree
                  data={hierarchyData}
                  orientation="vertical"
                  translate={{ x: 600, y: 100 }}
                  pathFunc="step"
                  renderCustomNodeElement={(rd3tProps) => renderForeignObjectNode({ ...rd3tProps, foreignObjectProps })}
                />
              </div>
            ) : (
              <div className="add_form_container">No User Assigned</div>
            )}
            <BuilderModal isOpen={isEditopen} onClose={() => setIsEditopen(false)} modalName="Add Designation">
              <UpdateUserNode
                nodeData={isEditopen}
                editUser={editUser}
                setIsEditopen={setIsEditopen}
                filterManagers={filterManagers}
              />
            </BuilderModal>
          </div>
        </div>
      )}
    </div>
  );
};

export default OrgStructure;

const UpdateUserNode = ({ nodeData, editUser, setIsEditopen, filterManagers }) => {
  const [role, setRole] = useState("");
  const [manager, setManager] = useState("");
  const [allowedManagers, setAllowedManagers] = useState([]);

  const handleEditRole = () => {
    editUser(nodeData.user_id, role, manager);
    setIsEditopen(false);
  };

  useEffect(() => {
    const mangaerList = filterManagers(nodeData.user_id);
    setAllowedManagers(mangaerList);
    setRole(nodeData?.designation);
    setManager(nodeData?.manager_id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="builder_form">
      <Input label="Enter Designation" type="text" value={role} onChange={(e) => setRole(e.target.value)} />

      <SingleSelectBox
        selectedData={manager}
        options={allowedManagers}
        onChange={(obj) => setManager(obj.id)}
        placeholder="Select manager"
        label="Select Manager"
        isSearch={true}
      />

      <Button onClick={handleEditRole}>Save</Button>
    </div>
  );
};
